import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseFive/warehouseFive.webp";

function WarehouseFive(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
            <div className="warehouseFive">
              <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'200px'} />
              <div className="warehouseFiveText">
                <h1 className={`${isVisible ? 'visible' : ''}`}>{t("warehouse_five_title")}</h1>
                <p className={`${isVisible ? 'visible' : ''}`}>
                  {t("warehouse_five_text")}
                </p>
              </div>
            </div>
        </VisibilitySensor>
    )
}
export default WarehouseFive;